import React from "react";

import { makeStyles, Container, Typography } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {},
  LawsTable: {
    width: "80%",
    backgroundColor: "none",
    borderCollapse: "collapse",
    borderWidth: "1px",
    borderColor: "#4B5462",
    borderStyle: "solid",
    color: "#000000",
    "& td, & th": {
      borderWidth: "1px",
      borderColor: "#4B5462",
      borderStyle: "solid",
      padding: "3px",
    },
    "& thead": {
      backgroundColor: "none",
    },
  },
}));

export const PrivacyPage: React.FC = () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Container maxWidth="lg">
        <Typography variant="h1" paragraph>
          Privacy Policy
        </Typography>

        <h1>Privacy Policy</h1>

        <h2>Identity of the Data Controller and Contact Details</h2>
        <p>
          “Data controllers” are the people who or organisations which determine
          the purposes for which, and the manner in which, any Personal Data is
          processed, who/which make independent decisions in relation to the
          Personal Data and/or who/which otherwise control that Personal Data.
        </p>
        <p>
          For the purposes of the GDPR, Ardrar Limited, t/a Swyft Energy is the
          data controller with regard to the Personal Data described in this
          Privacy Policy and Notice. Swyft Energy is based in Ireland and is
          focused on simplifying the installation of energy products in the
          home.
        </p>
        <p>
          Our Data Protection Co-Ordinator can be contacted as follows:- Email:
          dataprotection@swyftenergy.ie
        </p>

        <h2>Purpose and Scope</h2>
        <p>
          The purpose of this document is to provide you as our data subject
          with a statement regarding the Data Protection and Privacy practices
          and obligations of Swyft Energy, [the Organisation] and an explanation
          of your rights as a data subject. This Notice applies to our business
          practices, our website, which is accessible from
          https://www.swyftnergy.ie/ its sub-domains, as well as any associated
          mobile applications (Mobile Apps) owned and controlled by the
          Organisation. As the Organisation is established in the Republic of
          Ireland, this document is written in the vein of Irish Data Protection
          Law and the Organisation falls under the jurisdiction of the Irish
          Data Protection Commission. This Privacy Notice sets out what Personal
          Data we collect and process about you in connection with the services
          and functions of the Organisation. We are not responsible for the
          content or the privacy notices for any websites to which we provide
          external links.
        </p>
        <p>Laws that apply to us:</p>

        <table className={classes.LawsTable}>
          <thead>
            <tr>
              <th>State and/or Country of Incorporation</th>
              <th>Applicable Law</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Ireland</td>
              <td>
                <ul>
                  <li>
                    {" "}
                    General Data Protection Regulation (EU Regulation 679/2016)
                  </li>
                  <li> Data Protection Act 2018</li>
                  <li> Regulations flowing from DPA 2018</li>
                  <li> Data Protection Act 1988 Revised</li>
                  <li>
                    {" "}
                    ePrivacy Regulations 2011 implementing EU Privacy and
                    Electronic Communications Directive 2002/58/EC on Privacy
                    and Electronic Communications, otherwise known as ePrivacy
                    Directive (ePD)
                  </li>
                </ul>
              </td>
            </tr>
          </tbody>
        </table>

        <h2>Updates</h2>
        <p>
          Our practices as described here now may be changed, but any changes
          will be posted, and changes will only apply to activities and
          information on a going forward, not retroactive basis. You are
          encouraged to review this Notice periodically to make sure that you
          understand how any personal information you provide will be used. We
          may also email you to let you know if and when we update this Notice
          to ensure you are informed.
        </p>
        <p>
          Any changes to this Privacy Policy and Notice will be posted on this
          website so you are always aware of what information we collect, how we
          use it, and under what circumstances, if any, we disclose it. If at
          any time we decide to use Personal Data in a manner significantly
          different from that stated in this Privacy Policy and Notice, or
          otherwise disclosed to you at the time it was collected, we will
          notify you by email, and you will have a choice as to whether or not
          we use your information in the new manner.
        </p>

        <h2>Why and how do we ensure compliance?</h2>
        <p>
          Data protection provides rights to individuals with regard to the use
          of their Personal Data by organisations, including our organisation.
          Irish and EU laws on data protection govern all activities we engage
          in with regard to our collection, storage, handling, disclosure and
          other uses of Personal Data.
        </p>
        <p>
          Compliance with the data protection rules is a legal obligation. In
          addition, our compliance with the data protection rules helps
          individuals to have confidence in dealing with us and helps us to
          maintain a positive reputation in relation to how we handle personal
          information.
        </p>
        <p>
          The data protection rules that apply to us are currently contained in
          the Data Protection Act 1988 Revised, the Data Protection Act 2018, in
          the ePrivacy Regulations 2011, the EU General Data Protection
          Regulation (EU Regulation 679/2016) (the “GDPR”) and in related
          legislation (together the “DPAs”).
        </p>
        <p>
          We need to demonstrate accountability for our data protection
          obligations. This means that we must be able to show how we comply
          with the applicable Data Protection and Privacy Laws, and that we have
          in fact complied with the laws. We do this, among other ways, by our
          written policies and procedures, by building data protection and
          privacy compliance into our systems and business rules, by internally
          monitoring our data protection and privacy compliance and keeping it
          under review, and by acting if our representatives, including
          employees or contractors, fail to follow the rules. We also have
          certain obligations in relation to keeping records about our data
          processing.
        </p>

        <h2>Who must comply?</h2>

        <p>
          All our representatives, which include employees and contractors, are
          required to comply with our Data Protection and Privacy Policy which
          inform this Privacy Policy and Notice when they process Personal Data
          on our behalf. We may disclose individuals’ information to trusted
          third parties for the purposes set out and explained in this document
          or as explained to you when we collect your data. We require all third
          parties to have appropriate technical and operational security
          measures in place to protect your Personal Data, in line with
          applicable Data Protection and Privacy Laws and our Policies.
        </p>

        <h2>What are the data protection principles and rules?</h2>
        <p>
          We aim to comply with the following principles found in Data
          Protection Law:
        </p>
        <p>
          Lawfulness, fairness and transparency – Personal data must be
          processed lawfully, fairly and in a transparent manner.
        </p>
        <p>
          Purpose Limitation. Personal data must be collected for specified,
          explicit and legitimate purposes and not further processed in a manner
          that is incompatible with those purposes.
        </p>
        <p>
          Data minimisation – Personal Data must be adequate, relevant and
          limited to what is necessary in relation to purposes for which they
          are processed.
        </p>
        <p>
          Accuracy – Personal data must be accurate and, where necessary, kept
          up to date. Inaccurate Personal Data should be corrected or deleted.
        </p>
        <p>
          Retention – Personal data should be kept in an identifiable format for
          no longer than is necessary.
        </p>
        <p>
          Integrity and confidentiality – Personal data should be kept secure.
        </p>
        <p>
          Accountability – Under the GDPR, we must not only comply with the
          above six general principles, but we must be able to demonstrate that
          we comply by documenting and keeping records of all decisions.
        </p>

        <h2>What types of personal data will we process?</h2>
        <h3>Personal Data</h3>
        <p>
          We will collect personal data with you in accordance with the purposes
          outlined in this document. This will be basic personal data used to
          facilitate a service type relationship usually your name and email
          address and from time to time billing information.
        </p>
        <h3>Special Category Personal Data</h3>
        <p>
          We will not collect special category data from you unless you are an
          employee in which case we would be obliged to do so under law.
        </p>
        <h3>Criminal Conviction Data</h3>
        <p>We will not collect criminal conviction data from you.</p>
        <h3>Children’s Personal Data</h3>
        <p>
          As our service is not aimed at children, if we are notified or learn
          that a child has submitted Personal Data to us through our digital or
          social media without the correct permissions or consents, we will
          delete such Personal Data. If you would like to make use of our
          services and you are not yet 18 years old, we require that an adult is
          present when you register, if registration is required. Where consent
          is required to process your Personal Data as a child, we will obtain
          that consent from the adult who is authorised to give the consent on
          your behalf. You must be at least 16 years old to create an account
          and engage in activities and transactions on our digital and social
          media. By creating an account or engaging in activities or
          transactions on our digital and social media, you affirm that you are
          at least 16 years old and are fully able to enter into and comply with
          our regular Terms of Use and this Privacy Policy and Notice.
        </p>

        <h2>Who has access to or processes personal data?</h2>
        <h3>Directors and Employees of the Business</h3>
        <p>
          Directors and employees of the Organisation who are bound by
          confidentiality agreements will process personal data on behalf of the
          business.
        </p>
        <h3>Service Providers</h3>
        <p>
          We may use trusted service providers who could be considered data
          processors, sub-processors or third parties. We need to have written
          agreements in place with all of our data processors and, before we
          sign each agreement, we need to have vetted and be satisfied with the
          processor’s data security. The agreements also need to contain
          specific clauses that deal with data protection. We require all third
          parties to have appropriate technical and operational security
          measures in place to protect your Personal Data, in line with Irish
          and EU laws on data protection. Any such organisation or individual
          will have access to personal information needed to perform these
          functions but may not use it for any other purpose.
        </p>
        <p>
          We use the following categories of third party service providers
          including data processors in the course of our business:
          <ul>
            <li>Contractors</li>
            <li>Suppliers</li>
            <li>Cloud Web and App Hosting Services</li>
            <li>
              Professional Service Providers such as Lawyers, Solicitors and
              Accountants
            </li>
            <li>Financial Transaction Providers</li>
            <li>Telecoms Service and Carrier Providers</li>
          </ul>
          Telecoms Service and Carrier Providers
        </p>
        <p>
          We may pass on your details if we are under a duty to disclose or
          share a Data Subject’s Personal Data in order to comply with any legal
          obligation, or in order to enforce or apply any contract with the Data
          Subject or other agreements; or to protect our rights, property, or
          safety of our employees, customers, or others. This includes reporting
          information about incidents (as appropriate) to the law enforcement
          authorities and responding to any requirements from law enforcement
          authorities to provide information and/or Personal Data to them for
          the purposes of them detecting, investigating and/or prosecuting
          offences or in connection with crime sentencing.
        </p>
        <p>
          Other than the above, we will not disclose personal information to any
          third party without your consent, or as listed herein, except in
          incidences where an individual is potentially at risk or where the law
          requires it.
        </p>

        <h2>Where does your data travel to?</h2>
        <h3>International Transfers</h3>
        <p>
          If we transfer your Personal Data out of the EEA, we ensure an
          adequate degree of protection is afforded to it by ensuring at least
          one of the following safeguards is implemented:
          <ol>
            <li>
              We will only transfer your Personal Data to countries that have
              been deemed to provide an adequate level of protection for
              Personal Data by the European Commission.{" "}
            </li>
            <li>
              Where we use certain service providers, we may use specific
              contracts approved by the European Commission which give Personal
              Data the same protection it has in Europe.{" "}
            </li>
            <li>
              Where we use providers based in the US, we may transfer data to
              them if they are part of the Privacy Shield which requires them to
              provide similar protection to Personal Data shared between the
              Europe and the US.{" "}
            </li>
          </ol>
        </p>

        <h2>Automated Decision Making and Profiling</h2>
        <p>
          Automated Decision Making refers to a decision which is taken solely
          on the basis of automated processing of your personal data. This means
          processing using, for example, software code or an algorithm, which
          does not require human intervention. As Profiling uses automated
          processing, it is sometimes connected with automated decision making.
          Not all profiling results in automated decision making, but it can do.
          We do not use automated decision making or profiling in our normal
          course of business.
        </p>

        <h2>Security</h2>
        <p>
          We follow strict security procedures in the storage and disclosure of
          your Personal Data, and to protect it against accidental loss,
          destruction or damage. We take appropriate security measures against
          unlawful or unauthorised processing of Personal Data, and against the
          accidental loss of, or damage to, Personal Data. The data you provide
          to us is protected using modern encryption, intrusion prevention, and
          account access techniques. We have put in place procedures and
          technologies to maintain the security of all Personal Data from the
          point of collection to the point of destruction. We use third party
          vendors and hosting partners to provide the necessary hardware,
          software networking, storage, and related technology required to run
          our business. Personal data will only be transferred to a data
          processor if they agree to comply with those procedures and policies,
          or if they put in place adequate measures themselves. We maintain data
          security by protecting the confidentiality, integrity and availability
          of the Personal Data, defined as follows:
        </p>
        <p>
          Confidentiality means that only people who are authorised to use the
          data can access it.
        </p>
        <p>
          Integrity means that Personal Data should be accurate and suitable for
          the purpose for which it is processed.
        </p>
        <p>
          Availability means that authorised users should be able to access the
          data if they need it for authorised purposes.
        </p>

        <h2>Data Retention</h2>
        <p>
          We have a documented data retention schedule. Generally, we will only
          retain your Personal Data for as long as necessary to fulfil the
          purposes we collected it for and for up to seven (7) years afterwards
          (for purposes related to Revenue requirements) or otherwise permitted
          by applicable laws. We may also retain your information during the
          period of time needed to complete our legitimate business operations,
          including for the purposes of satisfying any legal, accounting, or
          reporting requirements.
        </p>
        <p>
          To determine the appropriate retention period for Personal Data, we
          consider the amount, nature, and sensitivity of the Personal Data, the
          potential risk of harm from unauthorised use or disclosure of your
          Personal Data, the purposes for which we process your Personal Data
          and whether we can achieve those purposes through other means, and the
          applicable legal requirements.
        </p>

        <h2>Marketing</h2>
        <p>
          We may use your Personal Data to form a view on what we think you may
          want or need, or what may be of interest to you. This is how we decide
          which products, services and offers may be relevant for you.
        </p>
        <p>
          We strive to provide you with choices regarding certain Personal Data
          uses, particularly around marketing and advertising. Where
          appropriate, you will be asked whether you wish to receive any
          marketing communications from us.
        </p>
        <p>
          We will not share your Personal Data with any third party for
          marketing purposes. You may object to direct marketing by using the
          contact details herein to opt-out or make use of the opt-out links on
          communications.
        </p>

        <h2>Cookies and Other Technical Personal Data</h2>
        <h3>Cookies</h3>
        <p>
          Cookies are small text files that are transferred to your computer’s
          hard drive through your web browser to enable us to recognise your
          browser and help us to track visitors to our site. Most web browsers
          automatically accept cookies, but, if you wish, you can set your
          browser to prevent it from accepting cookies. The “help” portion of
          the toolbar on most browsers will tell you how to prevent your browser
          from accepting new cookies, how to have the browser notify you when
          you receive a new cookie, or how to disable cookies altogether.
        </p>

        <h3>Technical Personal Data</h3>
        <p>
          Like most websites, we gather statistical and other analytical
          information collected on an aggregate basis of all visitors to our
          website. We may gather technical information for security reasons. We
          will make no attempt to identify individual visitors, or to associate
          the technical details listed below with any individual. We will only
          use the technical information for statistical and other administrative
          purposes.
        </p>
        <p>
          We may collect this technical information from you when you visit our
          website and accept cookies. This information may include standard
          information from you (such as browser type and browser language), your
          Internet Protocol (“IP”) address, and the actions you take on our
          website (such as the web pages viewed and links clicked). We do note
          that your IP address is considered personal data under the GDPR.
        </p>
        <p>
          Certain information in relation to web usage is revealed via our
          internet service provider who records some of the following data.
          Whilst we do not access this information regularly, the technical
          information may be used to inform our security measures, to allow us
          improve the information we are supplying to our users, to find out how
          many people are visiting our sites and for statistical purposes. The
          information we receive depends upon what you do when visiting our
          site:
          <ul>
            <li>The IP address you are using.</li>
            <li>The date and time you access our site.</li>
            <li>The pages you have accessed and the documents downloaded.</li>
            <li>
              The previous Internet address from which you linked directly to
              our site.
            </li>
            <li>The user agent used to access our site.</li>
          </ul>
        </p>

        <h2>Sale of Business</h2>
        <p>
          Situations may arise where it is necessary to transfer information
          (including your Personal Data) to a third party in the event of a
          sale, merger, liquidation, receivership or transfer of all or
          substantially all of the assets of our organisation provided that the
          third party agrees to adhere to the terms of the Privacy Policy and
          Notice and provided that the third party only uses your Personal Data
          for the purposes that you provided it to us. The Personal Data
          transferred will be limited to that which is absolutely necessary. You
          will be notified in the event of any such transfer and you will be
          afforded an opportunity to opt-out.
        </p>

        <h2>Information on Consent</h2>
        <p>
          By consenting, where this is the appropriate grounds, to our
          processing your Personal Data in line with this Privacy Policy and
          Notice you are giving us permission to process your Personal Data
          specifically for the purposes identified.
        </p>
        <p>
          You may withdraw consent at any time by providing an unambiguous
          indication of your wishes by which you, by a statement or by a clear
          affirmative action, signify withdrawal of consent to the processing of
          Personal Data relating to you. If you have any queries relating to
          withdrawing your consent, please contact our Data Protection
          Co-Ordinator using the contact details set out below.
        </p>
        <p>
          Withdrawal of consent shall be without effect to the lawfulness of
          processing based on consent before its withdrawal.
        </p>

        <h2>CCTV in the Workplace</h2>
        <p>
          We do not own or operate CCTV cameras and we do not process CCTV
          footage.
        </p>

        <h2>Details of data processing activities</h2>

        <table className={classes.LawsTable}>
          <thead>
            <tr>
              <th>Categories of Data</th>
              <th>Purpose/Activity</th>
              <th>Possible Lawful Basis for Processing</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Name and Contact Details</td>
              <td>
                To manage our relationship with you as our customer, supplier,
                contractor or shareholder
              </td>
              <td>Performance of a contract with you</td>
            </tr>
            <tr>
              <td>Name and Contact Details</td>
              <td>Electronic account creation and/or management</td>
              <td>
                <ol>
                  <li>Performance of a contract with you</li>
                  <li>Necessary to comply with our legal obligation</li>
                </ol>
              </td>
            </tr>
            <tr>
              <td>Name and Contact Details</td>
              <td>
                To manage our relationship with you as a customer in our CRM
              </td>
              <td>
                <ol>
                  <li>Performance of a contract with you</li>
                  <li>
                    Necessary for our legitimate interests (ensure sales
                    continue)
                  </li>
                </ol>
              </td>
            </tr>
            <tr>
              <td>Social Media Handles or Profile IDs</td>
              <td>
                When you choose to engage with us via social media platforms and
                we need to respond.
              </td>
              <td>
                Necessary for our legitimate interests (ensure sales continue
                and to deal with issues customers raise)
              </td>
            </tr>
            <tr>
              <td>Name and Contact Details</td>
              <td>
                Use the Personal Data that you provide on our web forms and
                questionnaires
              </td>
              <td>
                Necessary steps to prior to entering into a contract with you
              </td>
            </tr>
            <tr>
              <td>Name and Contact Details</td>
              <td>Notifying you about changes to our terms or this policy</td>
              <td>Necessary to comply with our legal obligation</td>
            </tr>
            <tr>
              <td>Name and Contact Details</td>
              <td>Asking you to leave a review or take a survey</td>
              <td>
                Necessary for our legitimate interests (to keep our records
                updated and to study how customers use our products/services)
              </td>
            </tr>
            <tr>
              <td>Name and Contact Details; IP Address</td>
              <td>
                To administer and protect our business and website (including
                troubleshooting, data analysis, testing, system maintenance,
                support, reporting and hosting of data)
              </td>
              <td>
                <ol>
                  <li>
                    Necessary for our legitimate interests (for running our
                    business, provision of administration and IT services,
                    network security, to prevent fraud and in the context of a
                    business reorganisation or group restructuring exercise)
                  </li>
                  <li>Necessary to comply with a legal obligation</li>
                </ol>
              </td>
            </tr>
            <tr>
              <td>IP Address</td>
              <td>
                To use data analytics to improve our website, products/services,
                marketing, customer and investor relationships and experiences
              </td>
              <td>
                Necessary for our legitimate interest (to define types of
                customers for our products and services, to keep our website
                updated and relevant, to develop our business and to inform our
                marketing strategy)
              </td>
            </tr>
            <tr>
              <td>Name and Contact Details</td>
              <td>To respond to your enquiry, feedback or complaint</td>
              <td>
                <ol>
                  <li>Necessary to comply with a legal obligation</li>
                  <li>Performance of a contract with you</li>
                </ol>
              </td>
            </tr>
            <tr>
              <td>Name and Contact Details; Invoices</td>
              <td>To comply with our tax obligations.</td>
              <td>Necessary to comply with a legal obligation</td>
            </tr>
            <tr>
              <td>Voice/Video Data</td>
              <td>
                Record communications to use for evaluation and training
                purposes, ensure quality of service and courses, maintain a
                record of services requested.
              </td>
              <td>
                <ol>
                  <li>
                    Necessary for our legitimate interests (improving courses,
                    for running our business, provision of administration and IT
                    services, network security, to prevent fraud)
                  </li>
                  <li>Performance of a contract with you</li>
                </ol>
              </td>
            </tr>
          </tbody>
        </table>

        <h2>What rights do you have?</h2>
        <p>
          Under certain circumstances, by law you have the right to:
          <ul>
            <li>
              Request information about whether we hold personal information
              about you, and, if so, what that information is and why we are
              holding/using it.
            </li>
            <li>
              Request access to your personal information (commonly known as a
              “Data Subject access request”). This enables you to receive a copy
              of the personal information we hold about you and to check that we
              are lawfully processing it.
            </li>
            <li>
              Request correction of the personal information that we hold about
              you. This enables you to have any incomplete or inaccurate
              information we hold about you corrected.
            </li>
            <li>
              Request erasure of your personal information. This enables you to
              ask us to delete or remove personal information where there is no
              good reason for us continuing to process it. You also have the
              right to ask us to delete or remove your personal information
              where you have exercised your right to object to processing (see
              below).
            </li>
            <li>
              Object to processing of your personal information where we are
              relying on a legitimate interest (or those of a third party) and
              there is something about your particular situation which makes you
              want to object to processing on this ground. You also have the
              right to object where we are processing your personal information
              for direct marketing purposes.
            </li>
            <li>
              Object to automated decision-making including profiling, that is
              not to be subject of any automated decision-making by us using
              your personal information or profiling of you.
            </li>
            <li>
              Request the restriction of processing of your personal
              information. This enables you to ask us to suspend the processing
              of personal information about you, for example if you want us to
              establish its accuracy or the reason for processing it.
            </li>
            <li>
              Request transfer of your personal information in an electronic and
              structured form to you or to another party (commonly known as a
              right to “data portability”). This enables you to take your data
              from us in an electronically useable format and to be able to
              transfer your data to another party in an electronically useable
              format.
            </li>
          </ul>
        </p>

        <h2>How do you exercise your rights?</h2>
        <p>
          We have appointed a Data Protection Coordinator to monitor compliance
          with our data protection obligations and with this policy and our
          related policies. If you have any questions about this policy or about
          our data protection compliance, please contact the Data Protection
          Coordinator.
        </p>
        <p>
          Data subjects must make a formal request for Personal Data we hold
          about them or otherwise to exercise their data protections rights
          whether to make an access request or otherwise by contacting our Data
          Protection Coordinator who will respond to the request within 30 days.
        </p>
        <p>
          We are obliged to comply with exceptions to your requests where laid
          out in law. Such exceptions relate to health data, disclosures that
          would be likely to cause serious harm to your physical or mental
          health or emotional condition and opinions given in confidence.
        </p>
        <p>Our Data Protection Co-Ordinator can be contacted as follows:-</p>
        <p>Email: dataprotection@swyftenergy.ie</p>

        <h3>Your Right to Lodge a Complaint</h3>
        <p>
          You as the Data Subject have the right to complain at any time to a
          data protection supervisory authority in relation to any issues
          related to our processing of your Personal Data. As our organisation
          is located in Ireland and we conduct our data processing here, we are
          regulated for data protection purposes by the Irish Data Protection
          Commissioner.
        </p>
        <p>You can contact the Data Protection Commissioner as follows:</p>
        <p>Website: www.dataprotection.ie</p>
        <p>Phone: +353 57 8684800 or +353 (0)761 104 800</p>
        <p>Email: info@dataprotection.ie</p>
        <p>
          Address: Data Protection Office – Canal House, Station Road,
          Portarlington, Co. Laois, R32 AP23. Or 21 Fitzwilliam Square Dublin 2.
          D02 RD28 Ireland
        </p>

        <h2>Notice Approval</h2>
        <p>
          This Notice has been approved and authorised by the Swyft Energy Board
          of Directors on 25/11/2019
        </p>
        <p>Version 1.0</p>
      </Container>
    </div>
  );
};
